import { Link } from "react-router-dom";

const BuildTogetherCTA = () => {
  return (
    <section className="py-8 md:py-12 lg:py-16 bg-[#F9FAFF] mb-10 ">
      <div>
        {/* Wrapper that creates left space and sticks to right */}
        <div className="ml-0 lg:ml-16 xl:ml-24">
          <div className="p-6 md:p-8 lg:p-10 rounded-l-lg md:rounded-l-xl rounded-r-none">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10 items-center">
              {/* Left Side - Image */}
              <div className="relative h-64 md:h-80 lg:h-[300px] rounded-lg overflow-hidden">
                <img
                  src="/assets/home/6section.svg"
                  alt="Avexa office team collaboration"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Right Side - Content */}
              <div className="flex flex-col justify-center text-center lg:text-left items-center lg:items-start">
                <h2 className=" font-bold  mb-4 md:mb-5">
                  Build the next model of
                  <br />
                  <span className="block  mt-2 md:mt-3"></span>
                  <span className="">healthcare</span>
                </h2>

                <p className="  opacity-90 mb-6 md:mb-8 leading-relaxed">
                  Join forward-thinking healthcare organizations redefining how
                  care is delivered, experienced, and scaled.
                </p>
 
                <div>
                  <Link to="/get-in-touch#contactForm">
                    <button className="btn btn-primary"> Book a Demo</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildTogetherCTA;
